export default {
	"perforMeet": {
		"pickMeet": "提货预约",
		"prebookStatus": "预约状态",
		"senderAddress": "提货地址",
		"receiverAddress": "送货地址",
		"latestDeliveryDt": "要求提货时间",
		"latestReceivedDt": "要求送货时间",
		"orderAttachment": "下单附件",
		"togetherMeetTips": "是否将本派车单中提货地址相同的单据一起预约",
		"pickUpVehicleInfo": "提货车辆信息",
		"batchPickMeet": "批量提货预约",
		"batchMeet": "批量预约",
		"batchPickMeetFail": "批量提货预约失败",
		"meetFailMsg": "预约失败信息",
		"transportPickAddress": "运单提货地址",
		"transportReceiverAddress": "运单收货地址",
		"meetPickTimeTips": "请选择预约送货时间区间！",
		"pleaseSelectNoPickedTips": "请选择待提货的运单",
		"meetPickTimeRangeTips": "请选择预约提货时间区间！",
		"msgTips": "但未影响最终预约结果。请线下核对预约消息是否送达",
		"carrierNo": "承运商单号",
		"items": "项目",
		"sendTime": "发货时间"
	},
	"performGoods": {
		"batchPick": "批量提货",
		"waitingForPickUp": "待提货",
		"shipped": "已发运",
		"pickUpFailed": "提货失败",
		"driverHandle": "司机操作",
		"pickUp": "已提货",
		"delivered": "已送货",
		"rePickup": "重新提货",
		"pickupCompleted": "提货完成",
		"doBlank": "放空",
		"pickupGoodsTemp": "提货货温",
		"weight": "应提重量(千克)",
		"goodsQty": "应提货品量",
		"volume": "应提体积(方)",
		"packingQty": "应提包装数",
		"actualWeight": "实提重量",
		"actualVolume": "实提体积",
		"inputPickupInfo": "录入提货明细",
		"pickupService": "提货服务",
		"allPackingQty": "总箱数",
		"trackStatus": "跟踪状态",
		"thisOrderCreate": "此单产生了",
		"abnormalNo": "个异常",
		"pleaseHandleItInTime": "请及时处理",
		"isBatchPick": "是否继续批量提货?",
		"batchPickTips": "单据已经提交后台处理，处理完成后会通过系统信息通知您，在此期间请勿对单据操作提货/送货！",
		"pickupDtTips1": "提货完成时间不能早于【提货到达时间、提货开始时间】",
		"pickupDtTips2": "提货开始时间不能早于【提货到达时间】或 晚于【提货完成时间】",
		"pickupDtTips3": "提货到达时间不能早于【提货开始时间、提货完成时间】",
		"notOnlyOneTips": "请选择至少两个运单",
		"waybillStatusRequire": "运单状态必须为待提货状态",
		"laterThanTips": "确认提货完成时间晚于",
		"endTimeTips": "的运输结束时间？",
		"pickupArrivalDtTips": "请填写提货到达时间。",
		"overPickupArrivalDtTips": "提货到达时间必须早于当前时间。",
		"inputCapacityInfoTips": "请填写运力信息。",
		"isSureTips": "是否确定将",
		"emptyTheWaybillTips": "运单进行放空处理",
		"vehicleTemperatureTips": "车温请输入-100到100之间的数字",
		"sureToSubmit": "是否确定提交?",
		"selectServiceProvider": "选择提供增值服务的服务方",
		"serviceProvider": "服务提供方",
		"serviceWorkload": "填写提供的增值服务作业量",
		"baseService": "基本服务",
		"selectTheServiceProvider": "选择提供服务的服务方",
		"service": "服务",
		"inputServiceWorkload": "填写提供的服务作业量",
		"noServiceInfo": "暂无服务信息",
		"addedServiceTips": "增值服务有输入错误的地方，请改正！",
		"baseServiceTips": "基础服务有输入错误的地方，请改正！"
	},
	"performSendGoods": {
		"batchSendGoods": "批量送货",
		"sendGoodsfaile": "送货失败",
		"sendGoodsComplete": "送货完成",
		"refused": "拒收",
		"latestReceivedDt": "预计到货时间",
		"actualGoodsQty": "应收货品量",
		"inputGoodsInfo": "录入签收货物详情",
		"deliveryRemarks": "送货备注",
		"returnTransport": "返程运输",
		"returnOfGoodsTransport": "退货返程",
		"returnOfGoodsAddress": "退货地址",
		"returnCargoTemperature": "返程货温",
		"tips1": "将拒收的货物用所填写的车辆运回到指定地址",
		"returnTransportCarInfo": "填写返程运输车辆信息",
		"tips2": "是否真的要抛弃这些被拒收的货物？",
		"noReturn": "不返程",
		"batchDeliveryCompleted": "批量送货操作完成",
		"sendService": "送货成功",
		"deliveryBeginDt": "送货开始时间",
		"rejectedGoodsStatus": "收货状态",
		"tips3": "送货完成时间不能早于【送货到达时间、收货开始时间、提货完成时间】",
		"tips4": "收货开始时间不能早于【送货到达时间、提货完成时间】或 晚于【送货完成时间】",
		"tips5": "送货到达时间不能晚于【收货开始时间、送货完成时间】或 早于【提货完成时间】",
		"successfulExecution": "执行成功",
		"noInfo": "没有任何信息！",
		"tips6": "退货运单‘预计到达时间’必须在‘送货完成时间’",
		"tips7": "之后",
		"tips8": "拒收产生的运单或非末段运单不允许拒收！",
		"tips9": "送货完成时间必填！",
		"tips10": "返程货温请输入-100到100之间且最多只能一位小数的数字",
		"tips11": "车温请输入-100到100之间且最多只能一位小数的数字",
		"tips12": "是否继续批量送货",
		"tips13": "运单状态必须为运输中状态",
		"tips14": "是否确认批量送货",
		"tips15": "拒收产生的运单或非末段运单拒收货品量和拒收包装数必须为0！",
		"tips16": "请填写收货重量",
		"tips17": "收货货温请输入-100到100之间的数字",
		"uncollected": "未收",
		"partialRejection": "部分拒收",
		"all": "全收"
	},
	"performTransit": {
		"trackingNormal": "跟踪正常",
		"orderFinish": "单据已完成",
		"transshipmentInfo": "转运信息",
		"changeCarInfo": "换车信息",
		"changeCarTime": "换车时间",
		"mainLineDeparture": "干线发车",
		"trunkTime": "发车时间",
		"trunkArrived": "干线到达",
		"trunkArrivedTime": "到达时间",
		"pickupOfArrival": "提货到站",
		"pickupArrivalTime": "到站时间",
		"distribution": "干线配送",
		"distributionTime": "配送发车时间",
		"distributionCapacitys": "配送车辆信息",
		"changeCar": "换车",
		"transshipment": "转运",
		"monitoringInfo": "监控信息",
		"executeInfo": "执行情况",
		"batchCancel": "批量取消",
		"requirement": "要求",
		"project": "项目",
		"packingQty": "下单外包装数",
		"volume": "下单体积(方)",
		"weight": "下单重量(千克)",
		"realityInfo": "实际情况",
		"beginTime": "实际开始时间",
		"endTime": "实际结束时间",
		"finishLocationQty": "完成站点数",
		"finishTransportQty": "完成单数",
		"maxTemperature": "最高温度",
		"mixTemperature": "最低温度",
		"earliestBeginTime": "最早开始时间",
		"latestEndTime": "最晚结束时间",
		"pleaseSelectArrivedTime": "请选择到达时间！",
		"trunkArrivedTips": "只有“运输中且干线发车”的派车单才能做此操作。",
		"pleaseSelectTrunkTime": "请选择发车时间！",
		"trunkArrivedTips2": "只有“运输中且未发车或者未到达”的派车单才能做此操作。",
		"transportNoStatusTips": "只能选择状态是【新建/已计划/待提货】的运单",
		"uncheckWaybill": "确定取消选中运单吗?",
		"execute": "执行",
		"tips1": "单",
		"tips2": "成功",
		"tips3": "失败",
		"tips4": "失败原因",
		"tips5": "执行结果",
		"tips6": "运单",
		"tips7": "不是已发运状态，请勾选已发运状态的单据。",
		"tips8": "请选择到站日期。",
		"tips9": "请选择配送发车时间。",
		"tips10": "请添加配送车辆信息。",
		"warnTips": "预警与异常",
		"warnInfo": "预警信息",
		"warningTimeBegin": "预警时间",
		"cancelTime": "解除时间"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/perform/perform.js